import React, { Component } from "react";
import classnames from "classnames";
import { Link, Redirect } from "react-router-dom";
import EmailLogin from "./loginWithEmail";
import OtpLogin from "./loginWithOtp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setAuth, isAuth } from "../../../auth/authenticate";
import b from "../Background/final-logo.svg";
// import Axios from "../../../auth/axios";
import Modals from "./Modal/Modal";
import "./loginStyle.css";
import {
  loginWithPassword,
  sendLoginOtp,
  verifyLoginOtp,
  sendRegistrationOtp,
  newVendorRegistration,
  fetchVendorAllServices,
} from "../../Services/allServices";
import ModalForm from "./ModalForm/ModalForm";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { Helmet } from "react-helmet";
import ModalFormNext from "./ModalForm/ModalFormNext";

class Login extends Component {
  state = {
    activeTab: "1",
    username: "",
    password: "",
    mobileNumber: "",
    verifyOtp: "",
    verifySection: 0,
    otpButtonText: "Send OTP",
    isAuthenticated: isAuth(),
    isProcessingAuthenticated: isAuth(),

    // for modal
    collapse: true,
    fadeIn: true,
    modal: false,

    // for registration
    vendorFirstName: "",
    vendorLastName: "",
    vendorEmail: "",
    vendorPassword: "",
    vendorRepeatPassword: "",
    vendorMobileNumber: "",
    vendorVerifyOtp: "",
    vendorVerifyOtpSection: 0,
    registrationOtpButtonText: "Send OTP",
    status: "0",

    // vendor information
    firstName: "",
    lastName: "",
    selectedOption: [],
    options: [],
  };

  componentDidMount = async () => {
    const response = await fetchVendorAllServices();
    // console.log(response);
    var options = response.data.data.map((item) => {
      return {
        label: item.name,
        value: item._id,
      };
    });
    this.setState({ options });
    // console.log(options)
  };

  handleallServicesChange = (selectedOption) => {
    this.setState({
      selectedOption,
    });
  };

  changeStatusHandler = (value) => {
    const {
      vendorPassword,
      vendorRepeatPassword,
      vendorFirstName,
      vendorLastName,
      vendorEmail,
    } = this.state;

    if (value == "3") {
      if (!vendorFirstName)
        return toast.error("Enter your firstName!", { position: "top-right" });
      if (!vendorLastName)
        return toast.error("Enter your lastName!", { position: "top-right" });
      if (!vendorEmail)
        return toast.error("Enter your Email!", { position: "top-right" });
      if (!vendorPassword)
        return toast.error("Enter your Password!", { position: "top-right" });
      if (!vendorRepeatPassword)
        return toast.error("Enter re-enter password", {
          position: "top-right",
        });

      if (vendorPassword !== vendorRepeatPassword) {
        return toast.error(
          "Your Password DidNot Matched!! Please Try Again with same password!",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      } else {
        this.setState({
          status: value,
        });
      }
    } else {
      this.setState({
        status: value,
      });
    }
  };

  handleOnChange = (e) => {
    // console.log(e.target.name, e.target.value);
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onOtpChangeHandler = (ev) => {
    if (ev.target.value.length > 6) {
      return null;
    }
    this.setState({
      vendorVerifyOtp: ev.target.value,
    });
  };

  setCookie = (cname, cvalue, exdays) => {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  };

  getCookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

  onMobileChangeHandler = (e) => {
    if (e.target.value.length > 10) {
      return null;
    }
    this.setState({
      mobileNumber: e.target.value,
    });
  };

  onRegistrationMobileChangeHandler = (e) => {
    if (e.target.value.length > 10) {
      return null;
    }
    this.setState({
      vendorMobileNumber: e.target.value,
    });
  };

  sendRegistrationOtpHandler = async (ev) => {
    const { vendorMobileNumber } = this.state;
    const data = {
      mobile: vendorMobileNumber,
    };
    // console.log('handlerData => => ', data);
    const getOtp = await sendRegistrationOtp(data);
    // console.log('response => => ', getOtp);
    if (getOtp.data.error) {
      toast.error(getOtp.data.message);
      return null;
    }
    toast.success("OTP sent!");
    this.setState({
      vendorVerifyOtpSection: 1,
      registrationOtpButtonText: "Re-Send OTP",
    });
  };

  vendorRegistrationHandler = async (ev) => {
    ev.preventDefault();
    const {
      vendorFirstName,
      vendorLastName,
      vendorEmail,
      vendorPassword,
      vendorMobileNumber,
      vendorVerifyOtp,
      selectedOption,
    } = this.state;
    if (selectedOption == "") {
      return toast.error("Please Select Services!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (!vendorMobileNumber)
      toast.error("Enter your Mobile No.!", { position: "top-right" });
    else if (!vendorVerifyOtp)
      return toast.error("Enter OTP!", { position: "top-right" });
    else {
      let selectedOptionsFromVendor = selectedOption.map((service) => {
        return {
          serviceId: service.value,
          onlineMode: false,
          homeMode: false,
          centerMode: false,
        };
      });
      const data = {
        name: vendorFirstName,
        lname: vendorLastName,
        email: vendorEmail,
        mobile: vendorMobileNumber,
        password: vendorPassword,
        otp: vendorVerifyOtp,
        servicesAndModes: selectedOptionsFromVendor,
      };

      const result = await newVendorRegistration(data);
      // console.log('Result => => ', result);
      if (result.data.error) {
        toast.error(result.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        toast.success("Registered Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        this.changeStatusHandler("0");

        this.setState({
          vendorFirstName: "",
          vendorLastName: "",
          vendorEmail: "",
          vendorPassword: "",
          vendorRepeatPassword: "",
          vendorMobileNumber: "",
          vendorVerifyOtp: "",
          otpButtonText: "Send OTP",
        });
      }
    }
  };

  sendOtpHandler = async (e) => {
    const { mobileNumber } = this.state;
    const data = {
      mobile: mobileNumber,
    };
    // console.log('handlerData => => ', data);
    const getOtp = await sendLoginOtp(data);
    // console.log('response => => ', getOtp);
    if (getOtp.data.error) {
      toast.error(getOtp.data.message);
      return null;
    }
    toast.success("OTP sent!");
    this.setState({
      verifySection: 1,
      otpButtonText: "Re-Send OTP",
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { username, password } = this.state;
    const data = {
      username,
      password,
    };
    loginWithPassword(data)
      .then((res) => {
        // console.log(res)
        if (res.data.error === false) {
          if (
            res.data.vendor.personalInformation.personalDetailsComplete &&
            res.data.vendor.businessDetails.businessDetailsComplete &&
            res.data.vendor.educationalDetails.educationDetailsComplete &&
            res.data.vendor.serviceDetails.vendorServiceAndModeDetailsCompleted
          ) {
            // console.log('from ')
            this.setState({
              isAuthenticated: false,
              isProcessingAuthenticated: true,
            });
            this.props.history.push("/processing");
          } else {
            // console.log('from No')
            this.setState({
              isAuthenticated: true,
              isProcessingAuthenticated: false,
            });
            this.props.history.push("/registration");
          }
        } else {
          toast.error("Invalid UserName or Password!");
        }
      })
      .catch((err) => toast.error("Invalid userName or passWord!"));
  };

  vendorOtpLogin = async (event) => {
    event.preventDefault();
    const { mobileNumber, verifyOtp } = this.state;
    const data = {
      mobile: mobileNumber,
      otp: verifyOtp,
    };

    if (!mobileNumber)
      return toast.error("Enter Registered Mobile No.!", {
        position: "top-right",
      });

    // console.log(data);

    verifyLoginOtp(data)
      .then((res) => {
        if (res.data.error === false) {
          // console.log(res)
          if (
            res.data.vendor.personalInformation.personalDetailsComplete &&
            res.data.vendor.businessDetails.businessDetailsComplete &&
            res.data.vendor.educationalDetails.educationDetailsComplete &&
            res.data.vendor.serviceDetails.vendorServiceAndModeDetailsCompleted
          ) {
            this.setState({
              isAuthenticated: false,
              isProcessingAuthenticated: true,
            });
            this.props.history.push("/processing");
          } else {
            this.setState({
              isAuthenticated: true,
              isProcessingAuthenticated: false,
            });
            this.props.history.push("/registration");
          }
        }
      })
      .catch((err) => toast.error("Invalid OTP!"));
  };

  render() {
    const { isAuthenticated, isProcessingAuthenticated, status } = this.state;

    if (isProcessingAuthenticated === true) {
      // console.log('Processing')
      return <Redirect to="/processing" />;
    } else if (isAuthenticated === true) {
      // console.log('Registration')
      return <Redirect to="/registration" />;
    }

    return (
      <>
        <Helmet>
          <title>Vendor Panel-MomKidCare</title>
          <meta name="description" content="Hsp Login Page" />
          <meta property="og:title" content="Vendor login Panel" />

          <body style="background-color: #f1f5ff"></body>
        </Helmet>

        <div className="app flex-row align-items-center main-container">
          <ToastContainer position="bottom-center" autoClose={2000} />
          <Container>
            <Row className="mb-lg-5" style={{ width: "160px", margin: "auto" }}>
              <img src={b} />
            </Row>
            <Row className="justify-content-center">
              <Col md="10">
                <div className="cardHeight">
                  <Row className="m-2 m-lg-0">
                    <Col
                      md="6"
                      className="pt-5 marginSpacing d-none d-md-block"
                      style={{ background: "#094184", height: "520px" }}
                    >
                      <img
                        src="/assets/img/mainImage.svg"
                        className="img-fluid mb-2 img-style"
                        alt="img"
                        // style={{
                        //   maxWidth: "45%",
                        //   display: "block",
                        //   margin: "0 auto",
                        // }}
                      />
                      <p className="paragraph-style">Register Now</p>

                      <div
                        className="justify-content-center mt-5 mb-5"
                        style={{ display: "flex" }}
                      >
                        <div
                          style={{
                            // border: "1px solid black",
                            // height: "140px",
                            width: "16px",
                            // textAlign:"center",
                            // margin:"auto"
                          }}
                        >
                          <div
                            style={{
                              background: "white",
                              borderRadius: "50px",
                              height: "11px",
                              width: "11px",
                            }}
                          ></div>
                          <div
                            style={{
                              background: "white",
                              height: "6px",
                              width: "1px",
                              margin: "2px 5px auto",
                            }}
                          ></div>
                          <div
                            style={{
                              background: "white",
                              height: "6px",
                              width: "1px",
                              margin: "2px 5px auto",
                            }}
                          ></div>
                          <div
                            style={{
                              background: "white",
                              height: "6px",
                              width: "1px",
                              margin: "2px 5px auto",
                            }}
                          ></div>

                          <div
                            style={{
                              background: "white",
                              borderRadius: "50px",
                              height: "11px",
                              width: "11px",
                            }}
                          ></div>
                          <div
                            style={{
                              background: "white",
                              height: "6px",
                              width: "1px",
                              margin: "2px 5px auto",
                            }}
                          ></div>
                          <div
                            style={{
                              background: "white",
                              height: "6px",
                              width: "1px",
                              margin: "2px 5px auto",
                            }}
                          ></div>
                          <div
                            style={{
                              background: "white",
                              height: "6px",
                              width: "1px",
                              margin: "2px 5px auto",
                            }}
                          ></div>
                          <div
                            style={{
                              background: "white",
                              borderRadius: "50px",
                              height: "11px",
                              width: "11px",
                            }}
                          ></div>
                          <div
                            style={{
                              background: "white",
                              height: "6px",
                              width: "1px",
                              margin: "2px 5px auto",
                            }}
                          ></div>
                          <div
                            style={{
                              background: "white",
                              height: "6px",
                              width: "1px",
                              margin: "2px 5px auto",
                            }}
                          ></div>
                          <div
                            style={{
                              background: "white",
                              height: "6px",
                              width: "1px",
                              margin: "2px 5px auto",
                            }}
                          ></div>

                          <div
                            style={{
                              background: "white",
                              borderRadius: "50px",
                              height: "11px",
                              width: "11px",
                            }}
                          ></div>
                        </div>
                        <div
                          style={{
                            // border: "1px solid black",
                            // height: "140px",
                            width: "180px",
                            margin: "0px 7px",
                          }}
                        >
                          <div style={{ fontSize: "12px", color: "white" }}>
                            Refined Enquires
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              color: "white",
                              margin: "12px auto",
                            }}
                          >
                            Additional Revenue Stream
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              color: "white",
                              margin: "18px auto",
                            }}
                          >
                            No geographical Boundaries
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              color: "white",
                              // marginTop: "31px",
                            }}
                          >
                            Promotional Partner
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col
                      md="6"
                      className="secondDiv"
                      style={{
                        background: "white",
                        height: "520px",
                      }}
                    >
                      {status === "0" ? (
                        <EmailLogin
                          changeStatusHandler={this.changeStatusHandler}
                          handleOnChange={this.handleOnChange}
                          username={this.state.username}
                          password={this.state.password}
                          handleSubmit={this.handleSubmit}
                        />
                      ) : (
                        ""
                      )}

                      {status === "1" ? (
                        <OtpLogin
                          changeStatusHandler={this.changeStatusHandler}
                          handleOnChange={this.handleOnChange}
                          onMobileChangeHandler={this.onMobileChangeHandler}
                          sendOtpHandler={this.sendOtpHandler}
                          vendorOtpLogin={this.vendorOtpLogin}
                          otpButtonText={this.state.otpButtonText}
                          verifySection={this.state.verifySection}
                          verifyOtp={this.state.verifyOtp}
                          mobileNumber={this.state.mobileNumber}
                        />
                      ) : (
                        ""
                      )}

                      {status === "2" ? (
                        <ModalForm
                          changeStatusHandler={this.changeStatusHandler}
                          handleOnChange={this.handleOnChange}
                          vendorFirstName={this.state.vendorFirstName}
                          vendorLastName={this.state.vendorLastName}
                          vendorEmail={this.state.vendorEmail}
                          vendorPassword={this.state.vendorPassword}
                          vendorRepeatPassword={this.state.vendorRepeatPassword}
                          vendorMobileNumber={this.state.vendorMobileNumber}
                          vendorVerifyOtp={this.state.vendorVerifyOtp}
                          options={this.state.options}
                          selectedOption={this.state.selectedOption}
                          vendorVerifyOtpSection={
                            this.state.vendorVerifyOtpSection
                          }
                          onRegistrationMobileChangeHandler={
                            this.onRegistrationMobileChangeHandler
                          }
                          registrationOtpButtonText={
                            this.state.registrationOtpButtonText
                          }
                          sendRegistrationOtpHandler={
                            this.sendRegistrationOtpHandler
                          }
                          vendorRegistrationHandler={
                            this.vendorRegistrationHandler
                          }
                          onOtpChangeHandler={this.onOtpChangeHandler}
                          handleallServicesChange={this.handleallServicesChange}
                        />
                      ) : (
                        ""
                      )}
                      {status === "3" ? (
                        <ModalFormNext
                          changeStatusHandler={this.changeStatusHandler}
                          vendorMobileNumber={this.state.vendorMobileNumber}
                          vendorVerifyOtp={this.state.vendorVerifyOtp}
                          options={this.state.options}
                          selectedOption={this.state.selectedOption}
                          vendorVerifyOtpSection={
                            this.state.vendorVerifyOtpSection
                          }
                          onRegistrationMobileChangeHandler={
                            this.onRegistrationMobileChangeHandler
                          }
                          registrationOtpButtonText={
                            this.state.registrationOtpButtonText
                          }
                          sendRegistrationOtpHandler={
                            this.sendRegistrationOtpHandler
                          }
                          onOtpChangeHandler={this.onOtpChangeHandler}
                          handleallServicesChange={this.handleallServicesChange}
                          // handleOnChange={this.handleOnChange}
                          // vendorFirstName={this.state.vendorFirstName}
                          // vendorLastName={this.state.vendorLastName}
                          // vendorEmail={this.state.vendorEmail}
                          // vendorPassword={this.state.vendorPassword}
                          // vendorRepeatPassword={this.state.vendorRepeatPassword}
                          vendorRegistrationHandler={
                            this.vendorRegistrationHandler
                          }
                        />
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}

export default Login;
